$(function() {

	//showDoelBereikt();

	// BMI berekenen
	$('input[name="lengte"], input[name="gewicht"]').on('change', function(){
		calcBMI();
	});

	// $('select[name="tijdstip_vragenlijst"]').on('change', function(){
	// 	showDoelBereikt();
	// });
});


function calcBMI() {
	personLength = $('input[name="lengte"]').val();
	personWeight = $('input[name="gewicht"]').val();

	if (personLength !== '' && personWeight !== '') {
		personLength = Number(personLength);
		personWeight = Number(personWeight);

		if (personLength > 0 && personWeight > 0) {
			lengthUse = parseFloat(personLength/100,2);
			BMIresult = parseFloat(personWeight/(lengthUse*lengthUse)).toFixed(1);
		} else {
			BMIresult = 'ongeldige waarden';
		}

		$('input[name="BMI"]').val(BMIresult);
	}
}


function showDoelBereikt() {

	selectedTijd = $('select[name="form_fields[tijdstip_vragenlijst]"]').val();

	if (selectedTijd === '1_jaar_evaluatie_leefstijl') {
		$('textarea[name="form_fields[doel_bereikt]"]').parent().show();
	} else {
		$('textarea[name="form_fields[doel_bereikt]"]').parent().hide();
	}

}
